import { MAX_PHONE_NUMBER_LENGTH } from '@/consts';
import useLogin from './useLogin';
import { useState } from 'react';
import clsx from 'clsx';

const Login = () => {
  const {
    phoneNumber,
    password,
    isLoginBtnDisabled,
    isSaveIdChecked,
    isLoginErrorModalOpen,
    loginErrorMessage,
    loginErrorCount,
    onChangePhoneNumber,
    onChangePassword,
    onSubmit,
    onClickJoinBtn,
    handleSaveIdChange,
    onClickLoginErrorModalClose,
  } = useLogin();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const onChangePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  console.log('isLoginBtnDisabled', isLoginBtnDisabled);

  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="login-title heading-4 font-bold">로그인</h1>

        <form className="login-form">
          <div className="form-group">
            <label htmlFor="phone" className="form-label text-base font-medium">
              휴대폰번호를 입력해주세요
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              className="form-input"
              onChange={onChangePhoneNumber}
              value={phoneNumber}
              maxLength={MAX_PHONE_NUMBER_LENGTH}
            />
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              id="save-id"
              name="save-id"
              className="form-checkbox"
              checked={isSaveIdChecked}
              onChange={(e) => handleSaveIdChange(e.target.checked)}
            />
            <label htmlFor="save-id" className="checkbox-label text-base font-normal">
              아이디 저장
            </label>
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label text-base font-medium">
              비밀번호를 입력해주세요
            </label>
            <div className="password-wrapper">
              <input
                type={isPasswordVisible ? 'text' : 'password'}
                id="password"
                name="password"
                className="form-input"
                onChange={onChangePassword}
                value={password}
              />
              <button
                type="button"
                className="toggle-password"
                aria-label="비밀번호 표시"
                onClick={onChangePasswordVisibility}
              >
                <img
                  src={isPasswordVisible ? '/images/eye-active-icon.png' : '/images/eye-off-icon.png'}
                  alt="비밀번호 표시"
                  className="eye-icon"
                />
              </button>
            </div>
          </div>

          <button
            type="button"
            className={clsx('btn-primary signup-button text-lg font-semibold', {
              active: !isLoginBtnDisabled,
              default_cursor: isLoginBtnDisabled,
            })}
            // className="btn-primary signup-button text-lg font-semibold"
            id="loginBtn"
            onClick={onSubmit}
          >
            로그인
          </button>

          <a href="#" className="signup-link text-base font-medium" onClick={onClickJoinBtn}>
            회원가입
          </a>
        </form>
      </div>

      {/* 로그인 에러 모달 */}
      <div className={clsx('modal-overlay', !isLoginErrorModalOpen && 'hidden')} id="loginErrorModal">
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickLoginErrorModalClose}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-warning">
              <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
            </div>

            {loginErrorCount && (
              <p className="modal-error-count text-lg font-bold" >
                {`${loginErrorCount} / 10회`}
              </p>
            )}

            <h2
              className="modal-warning-title text-lg font-bold"
              dangerouslySetInnerHTML={{ __html: loginErrorMessage }}
            />

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickLoginErrorModalClose}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
